import { TLocaleCode } from 'types/i18n';

import { routeOverrides } from './routes';

export const resolvePath = (locale: TLocaleCode) => (path: string) =>
  routeOverrides[locale]?.[path] || path;
